import React from "react";
import { motion } from "framer-motion";

const partners = [
  "Mining & Heavy",
  "Manufacturing",
  "FMCG & Retail",
  "Agriculture",
  "Construction",
  "Automotive",
  "Chemicals",
  "Steel",
];

export default function LogoMarquee() {
  return (
    <section className="py-12 md:py-16 border-y border-[#E2E8F0] bg-[#F8FAFC]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center text-xs md:text-sm uppercase tracking-[0.24em] font-bold text-[#0070C0]"
        >
          Trusted across Southern Africa · industries we move
        </motion.p>

        <div className="mt-8 overflow-hidden no-scrollbar">
          <div className="flex gap-14 animate-marquee whitespace-nowrap">
            {[...partners, ...partners].map((l, i) => (
              <div
                key={i}
                className="font-display text-2xl md:text-3xl font-extrabold text-[#002050]/35 tracking-tighter hover:text-[#002050]/80 transition-colors"
              >
                {l}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
